/**
* A version of Array.isArray that works better with readonly arrays.
*
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
export const isArray = Array.isArray;
//# sourceMappingURL=isArray.js.map
